export { default } from './PartnerHomepage';
